// extracted by mini-css-extract-plugin
module.exports = {"badge":"shopBadges_badge__NpYKe"};